import { Observable, of } from "rxjs";
import { Annotation, PlottableModel, Transform } from "..";

/**
 * A reference to the object type unquie to the MapHelper implementation that represents a single plottable
 */
 export interface PlottableReference {
	plottable: PlottableModel<any>
	object: any
	boundingSphere?: any
	position?: any
}
/**
 * A renderer can be registered to a #MapHelper to determine how a plottable object is to be applied
 */
export class Renderer<T extends Annotation|Transform>{
	_debug_1:string = 'color:#fff;background-color:orange;'
	_debug_2:string = 'color:#fff;background-color:#666;'
	_log( id:string = 'constructor', data:any = null ) {
		if ( id == 'constructor' ) return; // hide constructor logging for now
		if ( id == 'onAdd' ) {
			if ( data && data[0] ) {
				data[0]['__renderer'] = this.constructor.name;
			}
			if ( data && data[1] ) {
				data[0]['__renderer_args'] = data[1];
			}
		}
		// console.log ( '%c '+this.constructor.name+' %c '+id+' ', this._debug_1, this._debug_2, data ? data : '' );
	}
	onAdd(obj:T,args?:any):Observable<PlottableReference>{
		throw new Error("Not implemented")
	}
	onUpdate(obj:T,pr:PlottableReference,args?:any):Observable<PlottableReference>{
		return of(pr)
	}
	onRemove(obj:T,pr:PlottableReference){
		throw new Error("Not implemented")
	}
	destory(){}
	monitorEvent( id:string, event:any ){
		return;
		const c = event.constructor.name + ':' + id;
		const me = this;
		if ( event ) {
			// me._log('addEventListener ['+c+']' );
			event.addEventListener( function(aa, bb, cc) {
				me._log('eventListener ['+c+'] result', [aa, bb, cc] );
			});
		}
	}
} 
